<script>
    export let type = 'submit';
    export let mode;
    export let disabled = false;
</script>
<style>
    button,
  button:focus {
    outline: none;
    padding-left: var(--space-3x);
    padding-right: var(--space-3x);
  }

  .success {
    background: #536f00;
    border-color: grey;
    color: white; 
  }

  .success:hover,
  .success:active {
    background: #688314;
    border-color: black;
  }

  .outline {
    background: transparent;
    color: #45724f;
    box-shadow: none;
  }
  

  .outline:hover,
  .outline:active {
    background: #eaeed8;
    box-shadow: none;
  }

  .outline:disabled,
  .outline:disabled:hover,
  .outline:disabled:active {
    background: transparent;
    color: #ccc;
  }

  .outline.success {
    border-color: #01a129;
    color: #01a129;
  }


  .outline.success:hover,
  .outline.success:active {
    background: #c2ffd1;
  }

  .nav {
    font-weight: 300;
    font-style: normal;
    background: transparent;
    border-color: transparent;
    font-size: var(--text-05);
    text-transform: uppercase;
    padding: 0px;
  }
  .brand {
    padding: 0px;
  }
</style>

<button class= "{mode}" type="{type}" on:click {disabled}>
  <span><p><slot /></p></span>
</button>
